export default __webpack_public_path__ + "static/media/el13.f1130a98.svg";